import { useEffect, useRef } from 'react';
import { format } from 'date-fns';
import { FaCheck } from 'react-icons/fa';
import { AiFillCloseCircle } from 'react-icons/ai';
import { JobApplication } from '@th-types/job-application.type';
import DATE_FORMATS from '@constants/dateFormat';
import { Form, Row } from 'react-bootstrap';
import { IWorkerData } from '@th-types/worker.type';
import { JobAssignment } from '@th-types/job.detail.type';
import '../style.css';

interface ApplicationInfoHeaderParams {
  worker: IWorkerData;
  jobAssignment: JobAssignment;
  jobApplication?: JobApplication;
  applicationDate?: string;
}

export default function ApplicationInfoHeader({
  jobAssignment,
  jobApplication,
  worker,
  applicationDate,
}: ApplicationInfoHeaderParams) {
  const hasApp = worker?.hasApp ?? false;
  const applicationStatusText =
    jobAssignment?.status.toString().replaceAll('_', ' ') || '';

  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const showIconHasApp = () => {
    return hasApp ? (
      <FaCheck className="mb-1" color="green" />
    ) : (
      <AiFillCloseCircle className="mb-1" color="red" />
    );
  };

  const resizeTextArea = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  };

  useEffect(resizeTextArea, [jobApplication?.applicationNote]);

  return (
    <>
      <p>
        <b className="fs-5">Application Info</b>
      </p>

      {jobAssignment?.status && (
        <p className="text-break my-1">
          <b>{applicationStatusText}&nbsp;&nbsp;</b>
          {applicationDate &&
            format(new Date(applicationDate), DATE_FORMATS.DATE_TIME_FORMAT)}
        </p>
      )}
      <p className="text-break my-1">
        <b>CELL&nbsp;&nbsp;</b>
        {worker.cellPhone}
      </p>
      <p className="text-break my-1">
        <b>EMAIL&nbsp;&nbsp;</b>
        {worker.email}
      </p>
      <p className="text-break my-1">
        <b>HAS APP?&nbsp;&nbsp;</b>
        {showIconHasApp()}
      </p>

      {!jobApplication?.applicationNote && (
        <p className="text-break my-1">
          <b>NOTE&nbsp;&nbsp;</b>
          N/A
        </p>
      )}
      {jobApplication?.applicationNote && (
        <Row>
          <p className="text-break mb-1">
            <b>NOTE</b>
          </p>
          <Form>
            <Form.Group>
              <Form.Control
                as="textarea"
                rows={1}
                ref={textAreaRef}
                style={{ resize: 'none', overflow: 'hidden' }}
                className="text-area"
                readOnly
                value={jobApplication?.applicationNote}
              />
            </Form.Group>
          </Form>
        </Row>
      )}
    </>
  );
}
